import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-file-create',
  templateUrl: './file-create.component.html',
  styleUrls: ['./file-create.component.css']
})
export class FileCreateComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
